import { useMutation } from "@tanstack/react-query";
import taskTemplateService from "../api/taskTemplateService";

export const useCreateTaskTemplate = () => {
  const { createTaskTemplate } = taskTemplateService();

  return useMutation({
    mutationKey: ["create-task-template"],
    mutationFn: async ({ taskTemplate }) => {
      const response = await createTaskTemplate(taskTemplate);
      return response.data;
    },
  });
};

export const useUpdateTaskTemplate = () => {
  const { updateTaskTemplate } = taskTemplateService();

  return useMutation({
    mutationKey: ["update-task-template"],
    mutationFn: async ({ taskTemplate }) => {
      const response = await updateTaskTemplate(taskTemplate);
      return response.data;
    },
  });
};

export const useUpdateRestoreDefault = () => {
  const { updateRestoreDefault } = taskTemplateService();

  return useMutation({
    mutationKey: ["update-restore-default"],
    mutationFn: async ({ restoreDefaultReq }) => {
      const response = await updateRestoreDefault(restoreDefaultReq);
      return response.data;
    },
  });
};

export const useDeleteTaskTemplate = () => {
  const { deleteTaskTemplate } = taskTemplateService();

  return useMutation({
    mutationKey: ["delete-task-template"],
    mutationFn: async ({ taskTemplate }) => {
      const response = await deleteTaskTemplate(taskTemplate);
      return response.data;
    },
  });
};

export const useDeleteMultipleTaskTemplates = () => {
  const { deleteMultipleTaskTemplates } = taskTemplateService();

  return useMutation({
    mutationKey: ["delete-multiple-task-templates"],
    mutationFn: async ({ taskTemplates }) => {
      const response = await deleteMultipleTaskTemplates(taskTemplates);
      return response.data;
    },
  });
};
